import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule, DatePipe, NgClass } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TableComponent } from 'app/layout/shared/table/table.component';
import { FuseCardComponent } from '@fuse/components/card';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { InputComponent } from 'app/layout/shared/input/input.component';
import { DatePickerComponent } from 'app/layout/shared/date-picker/date-picker.component';
import { ToastrService } from 'ngx-toastr';
import { SelectComponent } from 'app/layout/shared/select/select.component';
import { CMSStorageService } from 'app/core/service/CMS-Storage.service';
import { ENDPOINT_UTILS } from 'app/core/utils/end-point.utils';
import { HttpService } from 'app/core/service/http.service';

@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe],
  standalone: true,
  imports: [
    CommonModule,
    FuseCardComponent,
    TableComponent,
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    InputComponent,
    DatePickerComponent,
    SelectComponent,
    MatButtonModule,
    MatTabsModule
  ]
})
export class HolidaysComponent implements OnInit {
  holidayForm: FormGroup;
  clientHolidayForm: FormGroup;
  clientSearch: FormGroup;
  pageNumber = 1;
  pageSize = 10;
  sortBy = 'id';
  holidaysList: any;
  Role: string;
  employeeTableFields: any[];
  addHolidays = 'none'
  addClientHolidays = 'none'
  updateButton: boolean = false;
  holiday: any;
  date: any;
  day: any;
  saveHoliday: any;
  addButton: boolean;
  fromDate: any;
  holidayId: any;
  id: any;
  updateHoliday: any;
  holidayDate: string;
  holidayName: string;
  holidays: any;
  totalCount: any;
  isClientHolidayList: boolean = false;
  currentDate: Date = new Date();
  formattedDate: string = '';
  client: any;
  clientFields: any;
  clientId: any;
  MasterWeekend: any;
  clientNameAndWeekend: any;
  clientNameAndWeekendList: any;
  clientHolidayID: any;
  clientNameAndWeekendUpdata: any;
  clientName: any;
  weekendName: any;
  totalRecordCount: any;

  private readonly _router = inject(Router);
  private readonly _matDialog = inject(MatDialog);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);
  private readonly _formBuilder = inject(FormBuilder);
  public readonly toastrService = inject(ToastrService);
  private readonly httpService = inject(HttpService);
  private readonly cmsStorageService = inject(CMSStorageService);

  constructor() {
  }

  ngOnInit() {
    this.cmsStorageService.getItem().subscribe((data) => {
      this.Role = data.Role
    })
    this.getClient()
    this.holidayList()
    this.getholidayMasterWeekend()

    this.clientHolidayForm = this._formBuilder.group({
      clientName: ['', [Validators.required,]],
      weekends: ['', Validators.required],
    });

    this.clientSearch = this._formBuilder.group({
      clientName: [''],
    });

    this.holidayForm = this._formBuilder.group({
      clientName: ['', [Validators.required,]],
      holiday: ['', [Validators.required,]],
      selectdate: ['', Validators.required],
    });

    this.getAllClientHoliday()

    this.clientFields = this.getClientColumns();
    if (this.Role == 'Employee' || this.Role == 'ProjectManager' || this.Role == 'Frontend Developer' || this.Role == 'Technical Lead (Backend)' || this.Role == 'Technical Lead (Frontend)' || this.Role == 'Accounting Manager' || this.Role == 'Project Manager' || this.Role == 'Quality Assurance Lead' || this.Role == 'Fullstack Developer' || this.Role == 'Backend Developer' || this.Role == 'Quality Assurance' || this.Role == 'Financial Manager' || this.Role == 'HR Recruitment') {
      this.addButton = false
      this.holidayList()
      this.employeeTableFields = this.getCustomerColumns();
    } else if (this.Role == 'PM' || this.Role == 'Super Admin' || this.Role == 'HR Manager') {
      this.addButton = true
      this.holidayList()
      this.employeeTableFields = this.getCustomerColumn();
    }
  }

  getClient() {
    this.httpService.get(ENDPOINT_UTILS.master.getAllClientNames).subscribe((data: any) => {
      this.client = data['data'];
    })
  }

  onBack() {
    this._router.navigate(['/attendance/attendance-punch-in/attendance-punch-in'])
  }

  addNewNote(): void {
    this.holidayForm.reset()
    this.addHolidays = "block"
    this.updateButton = false
    this.holidayForm.get('clientName').enable()
  }

  getCustomerColumns(): any[] {
    return [
      { caption: '#', field: 'sno' },
      { caption: 'Festival', field: 'holiday' },
      { caption: 'Date', field: 'date' },
      { caption: 'Day', field: 'day' },
    ];
  }

  getClientColumns(): any[] {
    return [
      { caption: '#', field: 'sno' },
      { caption: 'Client Name', field: 'clientName' },
      { caption: 'Weekend', field: 'weekendName' },
      { caption: 'Action', field: 'action' },
    ];
  }

  getCustomerColumn(): any[] {
    return [
      { caption: '#', field: 'sno' },
      { caption: 'Festival', field: 'holiday' },
      { caption: 'Date', field: 'date' },
      { caption: 'Day', field: 'day' },
      { caption: 'Action', field: 'action' },
    ];
  }

  editRoute(event) {
    this.holidayId = event.id
    this.addHolidays = "block"
    this.updateButton = true
    this.holidayDate = event.date
    this.holidayName = event.holiday
    this.clientId = Number.parseInt(event.masterClientDTO.id)
    this.holidayForm.patchValue({
      clientName: Number.parseInt(event.masterClientDTO.id),
      holiday: event.holiday,
      day: event.day,
    })
    this.holidayForm.get('clientName').disable()
    this._changeDetectorRef.detectChanges()
  }

  pageNumbers(event) {
    this.pageNumber = event;
    this.holidayList();
    this.getAllClientHoliday();
  }

  holidayList() {
    const params = {
      pageNo: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      clientId: this.clientId
    };
    this.httpService.get(ENDPOINT_UTILS.master.holidayList, params).subscribe((data: any) => {
      this.holidaysList = data['data'];
      this.totalRecordCount = data['totalRecordCount'];
      this._changeDetectorRef.detectChanges()
    });
  }

  clearForm(): void {
    this.addHolidays = "none"
    this.addClientHolidays = "none"
    this.holidayForm.reset()
    this.clientHolidayForm.reset()
  }

  onFromDateChange(event) {
    this.fromDate = event;
    this.fromDate = new DatePipe('en-US').transform(this.fromDate.value, 'yyyy-MM-dd')
  }

  getholidayMasterWeekend() {
    this.httpService.get(ENDPOINT_UTILS.master.holidayMasterWeekend).subscribe((data: any) => {
      this.MasterWeekend = data['data'];
    })
  }

  clientChangeId(event) {
    this.clientId = event.value
    this.getAllClientHoliday()
  }

  sendForm() {
    this.holiday = this.holidayForm.value.holiday
    this.day = this.holidayForm.value.day
    this.fromDate = new DatePipe('en-US').transform(this.holidayForm.value.selectdate, 'yyyy-MM-dd')

    const params = {
      holiday: this.holiday,
      date: this.fromDate,
      day: this.day,
      clientId: this.clientId
    };

    this.httpService.post(ENDPOINT_UTILS.master.saveHoliday, '', params).subscribe((data: any) => {
      this.saveHoliday = data;
      if (data['status'] == 200) {
        this.toastrService.success(data['message'])
        this._matDialog.closeAll()
        this.clearForm()
        this.holidayList()
        this._changeDetectorRef.detectChanges()
      }
    });
    this.addHolidays = 'none'
    this._changeDetectorRef.detectChanges()
  }

  updateLeaveType() {
    this.holiday = this.holidayForm.value.holiday
    this.day = this.holidayForm.value.day
    if (this.holidayForm.value.selectdate) {
      this.fromDate = new DatePipe('en-US').transform(this.holidayForm.value.selectdate, 'yyyy-MM-dd')
    } else {
      this.fromDate = new DatePipe('en-US').transform(this.holidayDate, 'yyyy-MM-dd')
    }

    const params = {
      id: this.holidayId,
      holiday: this.holiday,
      date: this.fromDate,
      clientId: this.clientId
    };

    this.httpService.post(ENDPOINT_UTILS.master.saveHoliday, '', params).subscribe((data: any) => {
      this.saveHoliday = data;
      if (data['status'] == 200) {
        this.toastrService.success(data['message'])
        this.clearForm()
        this.holidayList()
        this.holidayForm.reset()
        this._changeDetectorRef.detectChanges()
        this.fromDate = null
      }
    });
    this._changeDetectorRef.detectChanges()
  }

  addClientHoliday() {
    this.clientHolidayForm.get('clientName').enable()
    this.addClientHolidays = 'block'
    this.updateButton = false
  }

  toggleHolidayList(isClient: boolean): void {
    this.isClientHolidayList = isClient;
  }

  onTabChange(event: any) {
    this.isClientHolidayList = event.index === 1;
  }

  onclientId(event) {
    this.clientId = event.value
    this.holidayList()
  }

  onOpenPopups(event) {
    this.addClientHolidays = 'block'
    this.updateButton = true
    this.clientHolidayID = event.id
    this.clientHolidayForm.patchValue({
      clientName: event.clientId,
      weekends: event.weekendId,
    })
    this.clientHolidayForm.get('clientName').disable()
  }

  clientWeekendSave() {
    if (this.updateButton) {
      this.id = this.clientHolidayID
    } else {
      this.id = 0
    }
    let data = {
      id: this.id,
      weekendId: this.clientHolidayForm.value.weekends,
      clientId: this.clientHolidayForm.value.clientName,
    }
    this.httpService.post(ENDPOINT_UTILS.master.clientWeekendSave, data).subscribe((data: any) => {
      this.clientNameAndWeekend = data;
      if (data['status'] == 200) {
        this.toastrService.success(data['message'])
        this.clearForm()
        this.clientHolidayForm.reset()
        this._changeDetectorRef.detectChanges()
        this.getAllClientHoliday()
      }
    });
    this.addClientHolidays = 'none'
  }

  getAllClientHoliday() {
    const params = {
      pageNo: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      clientId: this.clientId
    };
    this.httpService.get(ENDPOINT_UTILS.master.getAllClientHoliday, params).subscribe((data: any) => {
      this.clientNameAndWeekendList = data.data;
      this.totalCount = data['totalRecordCount'];
    });
  }

  pageNo(data) {
    this.pageNumber = data;
    this.holidayList()
    this.getAllClientHoliday()
  }
}
